module.exports = __webpack_public_path__ + "static/media/StudioA.af478a62.jpg";